import * as lodash from 'lodash';
import { cloneDeep } from 'lodash';
import { TrimCjContainer, TrimCjShape, TrimCjText } from '../../../../model/cj-factory';
import { TrimCjShadow } from '../../../../model/cj-factory/trim.cj-shadow';
import { TrimCjGraphics } from '../../../../model/cj-factory/trim.cj-graphics';
import { CJ_CONTAINER_NAME, CJ_DPOBJ_NAME } from '../../../../model/cj-factory/trim.cj-obj-name.collection';
import { TrimCjTool } from '../../../../../utilities/trim.cj-tool';
import { UuidGenerator } from '../../../../../utilities/uuid-generator';
import { TrimUiManager } from '../../../ui/trim.ui.manager';
import { TrimPrintManager } from '../../../../print/trim.print';
import {
  TextEditType,
  TrimTextAlignCodeType,
  TrimTextAlignStrType,
} from '../../../image-edit/text/trim.text-controller';
import { ThumbCreatorManager } from '../thumb.creator.manager';
import PixelConverter from '../../../../../utilities/pixel-converter';
import { TrimDataManager } from '../../../data/trim-data.manager';

type TextType = {
  id: string,
  text: string,
  y: number,
  x: number,
}

export class ThumbTextCreator {
  private stage: TrimCjContainer;
  // public orderPage?: OrderPageDataXml;

  private printManager!: TrimPrintManager;
  private thumbCreatorManager!: ThumbCreatorManager;

  private textData: TextType = {
    id: '',
    text: '',
    y: 0,
    x: 0,
  };

  fontType: '' | 'local' | 'server' = 'server';

  // textContainer?: TrimCjContainer;
  // textImage?: TrimCjText;
  backupText?: TrimCjText;
  backupTextContainer?: TrimCjContainer;
  outlineData?: TrimCjText;
  shadow?: TrimCjShadow;

  textMode: 'add' | 'reload' = 'add';
  textBox: TrimCjContainer[] = [];

  constructor(stage: TrimCjContainer) {
    this.stage = stage;
  }

  di(
    printMng: TrimPrintManager,
    thumbMng: ThumbCreatorManager,
  ): void {
    this.printManager = printMng;
    this.thumbCreatorManager = thumbMng;
  }

  initialize(): void {
  }

  destroy(): void {
    this.textData = { id: '', text: '', x: 0, y: 0 };
    this.fontType = 'server';
    // this.textContainer = undefined;
    // this.textImage = undefined;
    this.backupText = undefined;
    this.backupTextContainer = undefined;
    this.outlineData = undefined;
    this.shadow = undefined;
    this.textMode = 'add';
    this.textBox = [];
  }

  update(stage: TrimCjContainer): void {
    this.stage = stage;
  }

  textAlignFormat(textAlign: TrimTextAlignStrType) {
    switch (textAlign) {
      case 'left':
        return '0';
      case 'center':
        return '1';
      case 'right':
        return '2';
      default:
        return null;
    }
  };

  getTextAlign = (textAlign: TrimTextAlignCodeType) => {
    switch (textAlign) {
      case '0':
        return 'left';
      case '1':
        return 'center';
      case '2':
        return 'right';
      default:
        return 'left';
    }
  };

  // - テキストの挿入 -
  async addText(textId: string) {
    return new Promise<TrimCjContainer>((resolve) => {
      // await new Promise<void>((resolve) => {
      const newText = new TrimCjText();
      newText.set({
        textId,
        // y: this.textData.y,
        // x: this.textData.x,
        name: CJ_DPOBJ_NAME.dateText,
        originPos: {
          y: this.textData.y,
          x: this.textData.x,
        },
      });
      const pageId = this.printManager.currentPrint?.id ?? `layout-order:${UuidGenerator.create()}`;
      // フォント読み込み用遅延
      setTimeout(() => {
        const textContainer = new TrimCjContainer(pageId, undefined, undefined, undefined, newText.textId);
        textContainer.name = CJ_CONTAINER_NAME.dateText;
        textContainer.addChild(newText);
        // textContainer.mouseEnabled = false;
        textContainer.set({
          y: this.textData.y,
          x: this.textData.x,
        });
        // this.textImage = newText;
        // this.textEvent.setFocus(textContainer);
        // this.textEvent.setTextEvent(newText, textContainer);
        this.stage.addChild(textContainer);
        this.backupText = cloneDeep(newText);
        this.backupTextContainer = cloneDeep(textContainer);
        this.textBox.push(textContainer);
        resolve(textContainer);
      });
    });
  }

  // FIXME: Undo時に最終的にはテキストを消す。アウトラインとシャドウ併用時挙動に不具合あり
  // - テキストの挿入 -
  async editText( editPram: TextEditType, backupText: TrimCjText, isRestore?: boolean, callback?: () => void) {
    const {font, id, text, textAlign, options, color, rotation, lineHeight, alpha} = editPram;
    console.log('bbb: ', cloneDeep(this.stage));
    const textContainer = TrimCjTool.getDateTextContainer(this.stage);
    const pxSize = PixelConverter.ptToPx(Number(font.size.replace('pt', ''))) / TrimDataManager.getAdditionalValue + 'px';
    console.log(textContainer);
    if (!textContainer) return;
    const textData = TrimCjTool.getDateText(textContainer as TrimCjContainer);
    console.log(textData);
    if (!textData) return;
    const step = textData.text ? 'edit' : 'create';
    // -- テキスト装飾 --
    textData.fontData = font;
    textData.options = options;
    textData.font = `${font.isBold} ${font.isItalic} ${pxSize} ${font.family}`.trim();
    textData.text = text;
    textData.alpha = alpha;
    textContainer.rotation = rotation;
    textData.color = color;
    textData.textAlign = textAlign;
    textData.lineHeight = textData.getMeasuredLineHeight() + Number(lineHeight);
    const textBounds = textData.getBounds();
    switch (textAlign) {
      case 'center':
        textData.x = textBounds.width / 2;
        textData.margin = textBounds.width / 2;
        break;
      case 'right':
        textData.x = textBounds.width;
        textData.margin = textBounds.width;
        break;
      default:
        textData.x = 0;
        textData.margin = 0;
        break;
    }
    // -- アウトライン設定時は複製して重ねる --
    if (options.outline) {
      if (TrimCjTool.checkOutline(textContainer)) {
        const prevOutline = TrimCjTool.getOutline(textContainer);
        textContainer.removeChild(prevOutline);
      }
      const outlineText = textData.clone();
      outlineText.mouseEnabled = false;
      outlineText.name = CJ_DPOBJ_NAME.outline;
      outlineText.outline = Number(options.outline);
      outlineText.color = options.outlineColor;
      textContainer.addChild(outlineText);

      if (options.isShadow) {
        this.shadow = new TrimCjShadow(options.shadowTransparency, Number(options.offset), Number(options.offset), 0);
        outlineText.shadow = this.shadow;
      } else {
        (outlineText.shadow as createjs.Shadow | null) = null;
      }

    } else {
      if (TrimCjTool.checkOutline(textContainer)) {
        const prevOutline = TrimCjTool.getOutline(textContainer);
        textContainer.removeChild(prevOutline);
      }
    }
    if (options.isShadow) {
      this.shadow = new TrimCjShadow(options.shadowTransparency, Number(options.offset), Number(options.offset), 0);
      textData.shadow = this.shadow;
    } else {
      (textData.shadow as createjs.Shadow | null) = null;
    }
    // textContainer.rotation = rotation;
    const textTfBounds = textData.getTransformedBounds();
    const hitArea = new TrimCjShape();
    hitArea.set({
      x: hitArea.x,
      y: hitArea.y,
      graphics: new TrimCjGraphics().f('#FFFFFF').dr(-(textData.margin), 0, textTfBounds.width, textTfBounds.height),
    });
    textData!.hitArea = hitArea;
    this.fontType = options.fontType;
    this.stage.addChild(textContainer);
    textContainer.x = this.thumbCreatorManager.templateBaseVirtual.w - (textBounds.width * 1.3)
    textContainer.y = this.thumbCreatorManager.templateBaseVirtual.h - (textBounds.height + textBounds.width * 0.3)
    textContainer.fontName = font.family;
    textContainer.bold = font.isBold;
    textContainer.italic = font.isItalic;
    textContainer.textSize = pxSize;
    textContainer.horizontalAlignment = this.textAlignFormat(textAlign);
    textContainer.borderSize = String(options.outline);
    textContainer.borderColor = options.outlineColor;
    textContainer.rotation = rotation;
    textContainer.dropShadow = {
      enable: options.isShadow,
      transparence: options.shadowTransparency,
      virtualSize: Number(options.offset),
    };
  }

  async restoreDo(orderText: TextEditType, backup: TrimCjText) {
    return new Promise<void>(async (resolve) => {
      TrimUiManager.ins.emit('t->r:web-font:get-list', {
        callback: async (p) => {
          TrimUiManager.ins.emit('t->r:web-font:download', {
            fontFamilyName: orderText.font.family,
            callback: () => {
              this.editText({
                ...orderText,
                font: { ...orderText.font, family: 'ＭＳ ゴシック' },
                options: { ...orderText.options, fontType: 'server' }
              }, backup, true);
              resolve();
            },
            error: (msg: string) => {
              alert('フォントの読み込みに失敗しました。');
            },
          });
        },
      });
    });
  }

  async createDateText() {
    const print = this.printManager.currentPrint;
    const dateText = print?.base.getDateTextWindow();
    const base = print?.base.getImageWindow();
    const image = this.printManager.editableImage;
    if (dateText?.object?.text?.value && base) {
      const text = dateText.object.text;
      this.textData.y = dateText?.virtual.pos.y ?? 0;
      this.textData.x = dateText?.virtual.pos.x ?? 0;
      const textId = `text:${UuidGenerator.create()}`;
      const textContainer = await this.addText(textId);
      const cjText = TrimCjTool.getDateText(textContainer);
      const backup = lodash.cloneDeep(cjText);
      await this.editText({
        id: backup.textId ?? '',
        // text: 'てすとです、これはテストです',
        text: text.value,
        color: text.style.color,
        alpha: 1,
        rotation: 0,
        textAlign: this.getTextAlign(text.style.alignment),
        lineHeight: 0,
        font: {
          isBold: text.style.bold ? 'bold' : '',
          isItalic: text.style.italic ? 'italic' : '',
          size: text.point/10 + 'pt',
          family: text.font,
          // family: text.font,
        },
        options: {
          fontType: 'server',
          isShadow: false,
          shadowTransparency: `rgba(0, 0, 0, 0)`,
          offset: 0,
          outlineColor: text.style.outline.color,
          outline: 0,
          // outline: text.style.outline.width,
        }
      }, backup, true);
    }
    // if (this.orderPage && this.orderPage.viewModel.orderText) {
    //   for (const orderText of this.orderPage?.viewModel.orderText?.data || []) {
    //     this.textData.y = Number(orderText.textRect?.virtual?.y ?? 0);
    //     this.textData.x = Number(orderText.textRect?.virtual?.x ?? 0);
    //     const textContainer = await this.addText();
    //     const text = TrimCjTool.getText(textContainer);
    //     const backup = lodash.cloneDeep(text);
    //     await this.restoreDo(orderText, backup);
    //   }
    // }
  }
}
